import { render, staticRenderFns } from "./UldkInfo.vue?vue&type=template&id=14b9fd47&scoped=true&"
import script from "./UldkInfo.vue?vue&type=script&lang=js&"
export * from "./UldkInfo.vue?vue&type=script&lang=js&"
import style0 from "./UldkInfo.vue?vue&type=style&index=0&id=14b9fd47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b9fd47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VIcon,VList,VListItem,VListItemAction,VListItemContent,VRow})
